var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-autocomplete',{attrs:{"disabled":_vm.disabled,"fetch-suggestions":_vm.search,"clearable":"","value-key":_vm.itemName,"placeholder":_vm.placeholder},on:{"blur":_vm.blur,"clear":_vm.clearItem,"select":_vm.selectItem},model:{value:(_vm.values),callback:function ($$v) {_vm.values=$$v},expression:"values"}})
}
var staticRenderFns = []

export { render, staticRenderFns }